import Vue from "vue";
import uuidv1 from "uuid/v1"
import tabpageUtil from "../../utils/storage/tabpageUtils"
import { clone, findIndex } from "lodash"

// initial state
const state = {
  tabs: [],
  currentTab: {}
};

// getters
const getters = {
  getTabPages(state) {
    return state.tabs;
  },
  getCurrentTab(state) {
    return state.currentTab
  },
  getCurrentTabStatusInfo(state) {
    return state.currentTab.statusInfo
  }
};

// actions
const actions = {
  // clearError({ commit }) {
  //   commit('setError', undefined);
  // }
};

// mutations
const mutations = {
  initTabs(state, payload = {}) {
    state.tabs = tabpageUtil.getAllTabpages()
  },
  setCurrentTabByStatusCode(state, payload = { statusCode: undefined }) {
    let tab = state.tabs.filter(item => {
      return item.statusCode === payload.statusCode
    })[0]
    state.currentTab = tab
  },
  // updataTabs() { },
  // shiftTabs() { },
  pushTab(state, payload = {
    title: undefined,
    pathname: undefined,
    pathquery: null,
    // pathparams: null,
    type: undefined, //index | movieLib | movies
    // movieIds: [],
    statusInfo: {
      mainMovie: undefined,
      movieList: [],
      filters: {}
    }
  }) {
    let data = clone(payload)
    //如果已经存在相同对比影片的页签或者档期/影片库，返回已经存在的id
    let existId = tabpageUtil.isExistTabpage(data, clone(state.tabs))
    if (existId) {
      data.statusCode = existId
    } else {
      data.statusCode = uuidv1()
      //add tab and slice to last 20
      state.tabs.push(data)
      if (state.tabs.length > 20) {
        state.tabs = state.tabs.slice(-20)
      }
      //update localstorage
      tabpageUtil.updateTabpages(clone(state.tabs))
    }
    //change current tab
    state.currentTab = data
    return state;
  },
  updateCurrentTab(state, payload = { statusInfo: {} }) {
    state.currentTab.statusInfo = Object.assign(state.currentTab.statusInfo, payload.statusInfo)
    tabpageUtil.updateTabpages(state.tabs)
    return state
  },
  closeTab(state, payload = { statusCode: undefined }) {
    let index = findIndex(state.tabs, function (o) {
      return o.statusCode === payload.statusCode
    })
    state.tabs.splice(index, 1)
    tabpageUtil.updateTabpages(state.tabs)
  },
  closeMultiTab(state, payload = { statusCodeArr: [] }) {
    state.tabs = state.tabs.filter(item => {
      return !payload.statusCodeArr.includes(item.statusCode)
    })
    tabpageUtil.updateTabpages(state.tabs)
  },
  // moveTabs() { }

  //set current tab
  // setCurrentTab(state, payload = { statusCode: undefined }) {
  //   state.currentTab = payload.statusCode
  // }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
